import { useState, useEffect } from "react";
import styles from "./index.module.scss";
import Checkbox from "../../../components/Checkbox/Checkbox";
import { DeleteTasks, GetErrorTasks, ResetErrorTasks } from "../../../ApiCalls";
import Button from "../../../components/UI/Button/Button";

export default function ErrorList() {
  const [searchValue, setSearchValue] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [items, setItems] = useState([]);

  const fetchData = async () => {
    try {
      const res = await GetErrorTasks();
      console.log("salim res", res);
      if (res?.data) {
        setItems(res.data.PTasks);
      }
    } catch (error) {
      console.error("Failed to fetch error tasks", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const selectItemHandler = (checked, item) => {
    let temp = [...selectedItems];
    if (checked) {
      temp.push(item);
    } else {
      let idx = temp.indexOf(item);
      if (idx > -1) temp.splice(idx, 1);
    }
    setSelectedItems(temp);
  };

  const handleRetry = () => {
    ResetErrorTasks(selectedItems)
      .then((res) => console.log(res))
      .catch((e) => console.log(e))
      .finally(() => {
        fetchData();
        setSelectedItems([]);
      });
  };

  const handleDelete = () => {
    DeleteTasks(selectedItems)
      .then((res) => console.log(res))
      .catch((e) => console.log(e))
      .finally(() => {
        fetchData();
        setSelectedItems([]);
      });
  };

  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      <div className={styles.searchBox}>
        <div>
          <i></i>
        </div>
        <input
          type="text"
          placeholder="Search..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>

      <div className={styles.titleCard}>
        <div className={styles.cardInfo}>PTask Name</div>
        <div className={styles.cardInfo}>Order Item</div>
        <div className={styles.cardInfo}>Order</div>
      </div>

      <div className={styles.content}>
        {filteredItems.map((item, index) => (
          <div className={styles.errorCard} key={index}>
            <div className={styles.checkbox}>
              <Checkbox
                type="checkbox"
                checked={selectedItems.includes(item.PTasks_id)}
                onChange={(e) =>
                  selectItemHandler(e.target.checked, item.PTasks_id)
                }
              />
            </div>
            <div className={styles.cardInfo}>{item.name}</div>
            <div className={styles.cardInfo}>{item.OrderItemName}</div>
            <div className={styles.cardInfo}>{item.OrderName}</div>
          </div>
        ))}
      </div>
      <div className={styles.row}>
        <div className={styles.smallSubmit}>
          <Button styleType="light" onClick={handleRetry}>
            Retry
          </Button>
        </div>
        <div className={styles.smallSubmit}>
          <Button onClick={handleDelete}>Delete</Button>
        </div>
      </div>
    </>
  );
}
